import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import { TextField } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { toast } from "react-toastify";
import { Accordion, AccordionDetails, AccordionSummary, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import EditFAQ from "../components/editors/EditFAQ";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import IBCalculator from "./IBCalculator";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

export default function PartnershipFAQ({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [value2, setValue2] = useState("one");
  const [data, setData] = useState([]);
  const [images, setImages] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [success2, setSuccess2] = useState(false);
  const [fail2, setFail2] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openAdd, setOpenAdd] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [faq, setFaq] = useState([]);
  const [editItem, setEditItem] = useState({});
  const [refresh, setRefresh] = useState(false);
  const hiddenFileInput = useRef([]);
  const faqImageFileInput = useRef();

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  useEffect(() => {
    let docs = langs.map((item) => ({
      language: item.attributes.language,
      boxes: [...Array(4)].map(() => ({
        title: "",
        desc: "",
        icon: "",
      })),
    }));
    setData(docs);

    let faqsDocs = langs.map((item) => ({
      language: item.attributes.language,
      title: "",
      img: "",
      faqs: [],
    }));
    setFaqs(faqsDocs);

    let openDocs = [];
    langs.map(() => {
      openDocs.push({ open: false });
    });
    setOpenAdd(openDocs);

    let faqDocs = [];
    langs.map(() => {
      faqDocs.push({ q: "", a: "" });
    });
    setFaq(faqDocs);

    async function getData() {
      try {
        const res = await fetch(`${API}/partnership`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        });

        const response = await res.json();
        const apiData = response.data?.attributes?.data || [];

        // Merge backend data with local data
        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                ...apiItem,
                boxes: apiItem.boxes || localItem.boxes,
              };
            }

            return localItem;
          });
        });

        const apiFaq = response.data?.attributes?.faq || [];

        setFaqs((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiFaq.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                faqs: apiItem.faqs || localItem.faqs,
                title: apiItem.title || localItem.title,
                img: apiItem.img || localItem.img,
              };
            } else {
              return localItem;
            }
          });
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    getData();
  }, [langs]);

  const submitData = (updateFaqs) => {
    fetch(`${API}/partnership`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: updateFaqs === true ? { faq: faqs } : { data: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        updateFaqs === true ? setSuccess2(true) : setSuccess(true);
      } else {
        updateFaqs === true ? setFail2(true) : setFail(true);
      }
    });
  };

  const handleImageChange = (e, index, imgIndex) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const imageURL = response[0]?.url;

        let updatedData = [...data];

        updatedData[index].boxes[imgIndex].icon = imageURL;

        fetch(`${API}/partnership`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { data: updatedData },
          }),
        }).then((res) => {
          if (res.ok) {
            setData(updatedData);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });
      });
    }
  };

  const handleFAQImageChange = (e, index) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const imageURL = response[0]?.url;

        let updatedData = [...faqs];

        updatedData[index].img = imageURL;

        fetch(`${API}/partnership`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { faq: updatedData },
          }),
        }).then((res) => {
          if (res.ok) {
            setFaqs(updatedData);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });
      });
    }
  };

  const uploadFAQ = async (index) => {
    if (faq[index]?.q !== "" && faq[index]?.a !== "") {
      let fullData = faqs;
      fullData[index]?.faqs.push(faq[index]);

      await fetch(`${API}/partnership`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { faq: fullData },
        }),
      }).then(async (res) => {
        setOpenAdd([
          ...openAdd.map((item, idx) => {
            if (idx === index) {
              return { ...item, open: false };
            } else {
              return item;
            }
          }),
        ]);
        setFaq([
          ...faq.map((item, idx) => {
            if (idx === index) {
              return { ...item, a: "", q: "" };
            } else {
              return item;
            }
          }),
        ]);
        if (res.ok) {
          setSuccess2(true);
        } else {
          setFail2(true);
        }
      });
    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  const deleteItem = async (index, indexx) => {
    const filteredFaqs = faqs.map((item, i) => {
      if (i === index && item.faqs) {
        return {
          ...item,
          faqs: item.faqs.filter((faq, j) => j !== indexx),
        };
      }
      return item;
    });

    await fetch(`${API}/partnership`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { faq: filteredFaqs },
      }),
    }).then(async (res) => {
      setFaqs(filteredFaqs);
      if (res.ok) {
        setSuccess2(true);
      } else {
        setFail2(true);
      }
    });
  };

  return (
    <>
      <TabContext value={value}>
        <Box sx={{ width: "100%" }}>
          <h3 style={{ textTransform: "capitalize" }}>IB Box & FAQ Settings</h3>

          <Box mt={2}>
            <ClearCacheButton
              keys={[
                CACHE_KEY.partnershipIb
              ]} />
          </Box>

          <Tabs
            value={value}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs">
            {langs?.map((item, index) => {
              return (
                <Tab
                  key={index}
                  sx={tabStyle}
                  value={index.toString()}
                  label={item.attributes.language}
                  icon={
                    <img
                      src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                      style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                    />
                  }
                  iconPosition="start"
                />
              );
            })}
          </Tabs>

          {loading ? (
            <></>
          ) : (
            <>
              {langs?.map((item, index) => {
                return (
                  <TabPanel value={index.toString()} key={index}>
                    <TabContext value={value2}>
                      <Tabs
                        value={value2}
                        onChange={handleChange2}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="secondary tabs">
                        <Tab sx={tabStyle} value="one" label="Boxes" />
                        <Tab sx={tabStyle} value="two" label="FAQs" />
                        <Tab sx={tabStyle} value="three" label="Calculator" />
                      </Tabs>

                      <TabPanel value="one">
                        <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                        <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 20,
                          }}>
                          {[...Array(4)].map((item, idx) => (
                            <div key={idx}
                              className="w-full flex-col gap-5"
                              style={{ alignItems: "flex-start" }}>
                              <h3>Box {idx + 1}</h3>

                              <div
                                className="group relative w-[50px] mt-4 rounded-[10px] overflow-hidden cursor-pointer border-2 border-sky-400"
                                onClick={() => hiddenFileInput.current[idx].click()}>
                                <img
                                  style={{
                                    width: "100%",
                                    aspectRatio: 1,
                                    objectFit: "cover",
                                    transition: "0.2s",
                                  }}
                                  src={
                                    data[index]?.boxes[idx]?.icon
                                      ? SERVER_DOMAIN + data[index].boxes[idx].icon
                                      : require("../assets/placeholder-image.png")
                                  }
                                />

                                <div className="group absolute top-0 left-0 w-full  h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                                  <CameraAltIcon
                                    style={{ fontSize: 25 }}
                                    className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                  />
                                </div>

                                <input
                                  type="file"
                                  accept="image/png, image/jpeg"
                                  onChange={(e) => handleImageChange(e, index, idx)}
                                  ref={(el) => (hiddenFileInput.current[idx] = el)}
                                  style={{ display: "none" }}
                                />
                              </div>

                              <TextField
                                label="Title"
                                sx={{ width: 500 }}
                                value={data[index]?.boxes[idx]?.title || ""}
                                onChange={(e) => {
                                  const newData = [...data];
                                  newData[index].boxes[idx].title = e.target.value;
                                  setData(newData);
                                }}
                              />

                              <TextField
                                label="Description"
                                multiline
                                rows={3}
                                sx={{ width: 500 }}
                                value={data[index]?.boxes[idx]?.desc || ""}
                                onChange={(e) => {
                                  const newData = [...data];
                                  newData[index].boxes[idx].desc = e.target.value;
                                  setData(newData);
                                }}
                              />
                            </div>
                          ))}
                        </div>

                        {user.perms[30]?.edit && (
                          <>
                            <div className="submitBTN" onClick={() => submitData(item, index)}>
                              Save Changes
                            </div>

                            <div className="divider"></div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                gap: 25,
                                flexWrap: "wrap",
                              }}></div>
                          </>
                        )}
                      </TabPanel>

                      <TabPanel value="two">
                        {faqs[index]?.faqs?.length > 0 && (
                          <>
                            <SuccessAlert show={success2} setShow={(v) => setSuccess2(v)} />
                            <ErrorAlert
                              show={fail2}
                              setShow={(v) => setFail2(v)}
                              message={"No changes were made to the current items"}
                            />
                          </>
                        )}
                        <div
                          style={{
                            width: "80%",
                          }}>
                          {faqs[index]?.faqs?.map((item, indexx) => {
                            return (
                              <div
                                key={indexx}
                                style={{
                                  display: "flex",
                                  position: "relative",
                                  alignItems: "center",
                                  justifyContent: "flex-start",
                                  gap: 10,
                                }}>
                                <Accordion
                                  sx={{
                                    border: "solid",
                                    borderColor: "#fafafa",
                                    borderWidth: "1.5px",
                                    width: "94%",
                                    margin: 0.1,
                                  }}>
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header">
                                    {item.q}
                                  </AccordionSummary>
                                  <AccordionDetails sx={{ backgroundColor: "#fafafa" }}>
                                    {item.a}
                                  </AccordionDetails>
                                </Accordion>
                                <div
                                  onClick={() => {
                                    setEditItem({ index: index, indexx: indexx });
                                  }}
                                  style={{ cursor: "pointer" }}>
                                  <IconButton
                                    sx={{
                                      color: "#888",
                                      "&:hover": {
                                        color: "var(--link)",
                                      },
                                      transition: "0.3s",
                                    }}>
                                    <EditIcon />
                                  </IconButton>
                                </div>
                                <div
                                  onClick={() => deleteItem(index, indexx)}
                                  style={{ cursor: "pointer" }}>
                                  <IconButton
                                    sx={{
                                      color: "#888",
                                      "&:hover": {
                                        color: "red",
                                      },
                                      transition: "0.3s",
                                    }}>
                                    <GridDeleteIcon />
                                  </IconButton>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {user.perms[30]?.edit && (
                          <div
                            className="addC"
                            style={{
                              minHeight: openAdd[index]?.open ? 380 : 45,
                              padding: openAdd[index]?.open ? 20 : 0,
                              width: "80%",
                              marginTop: 10,
                            }}>
                            {openAdd[index]?.open && (
                              <div
                                className="addContent"
                                style={{
                                  marginTop: 10,
                                  marginBottom: 20,
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}>
                                <TextField
                                  label="Question"
                                  sx={{ width: "90%" }}
                                  size="small"
                                  value={faq[index]?.q}
                                  onChange={(e) =>
                                    setFaq([
                                      ...faq.map((item, idx) => {
                                        if (idx === index) {
                                          return { ...item, q: e.target.value };
                                        } else {
                                          return item;
                                        }
                                      }),
                                    ])
                                  }
                                />
                                <TextField
                                  label="Answer"
                                  sx={{ width: "90%", mt: 2, mb: 2 }}
                                  size="small"
                                  multiline
                                  rows={4}
                                  value={faq[index]?.a}
                                  onChange={(e) =>
                                    setFaq([
                                      ...faq.map((item, idx) => {
                                        if (idx === index) {
                                          return { ...item, a: e.target.value };
                                        } else {
                                          return item;
                                        }
                                      }),
                                    ])
                                  }
                                />
                              </div>
                            )}
                            <div
                              className="addBTN"
                              onClick={() =>
                                openAdd[index]?.open
                                  ? uploadFAQ(index)
                                  : setOpenAdd([
                                    ...openAdd.map((item, idx) => {
                                      if (idx === index) {
                                        return { ...item, open: true };
                                      } else {
                                        return item;
                                      }
                                    }),
                                  ])
                              }
                              style={{
                                width: openAdd[index]?.open ? "70%" : "100%",
                                height: 45,
                              }}>
                              Add New
                              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
                            </div>

                            {openAdd[index]?.open && (
                              <div
                                onClick={() => {
                                  setOpenAdd([
                                    ...openAdd.map((item, idx) => {
                                      if (idx === index) {
                                        return { ...item, open: false };
                                      } else {
                                        return item;
                                      }
                                    }),
                                  ]);
                                  setFaq([
                                    ...faq.map((item, idx) => {
                                      if (idx === index) {
                                        return { ...item, a: "", q: "" };
                                      } else {
                                        return item;
                                      }
                                    }),
                                  ]);
                                }}
                                className="cancelBTN">
                                Cancel
                              </div>
                            )}
                          </div>
                        )}

                        <div className="divider"></div>

                        <h3 className="mb-3">FAQ Title</h3>
                        <TextField
                          label="Title"
                          sx={{ width: 350 }}
                          value={faqs[index]?.title || ""}
                          onChange={(e) => {
                            const newData = [...faqs];
                            newData[index].title = e.target.value;
                            setFaqs(newData);
                          }}
                        />

                        {user.perms[30]?.edit && (
                          <>
                            <div
                              className="submitBTN"
                              onClick={() => {
                                let updateFaqs = true;
                                submitData(updateFaqs);
                              }}>
                              Save Changes
                            </div>
                          </>
                        )}

                        <div className="w-2/12">
                          <h3 className="ml-3 mt-6">FAQs Image</h3>
                          <div
                            className="group relative w-full mt-2 rounded-[15px] overflow-hidden cursor-pointer border-2 border-sky-400"
                            onClick={() => faqImageFileInput.current.click()}>
                            <img
                              style={{
                                width: "100%",
                                aspectRatio: 1,
                                objectFit: "cover",
                                transition: "0.2s",
                              }}
                              src={
                                faqs[index]?.img
                                  ? SERVER_DOMAIN + faqs[index].img
                                  : require("../assets/placeholder-image.png")
                              }
                            />

                            <div className="group absolute top-0 left-0 w-full h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                              <CameraAltIcon
                                style={{ fontSize: 45 }}
                                className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                              />
                            </div>

                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              style={{ display: "none" }}
                              ref={faqImageFileInput}
                              onChange={(e) => handleFAQImageChange(e, index)}
                            />
                          </div>
                        </div>
                      </TabPanel>

                      <TabPanel value="three">
                        <IBCalculator user={user} index={index} />
                      </TabPanel>
                    </TabContext>
                  </TabPanel>
                );
              })}
            </>
          )}
        </Box>
      </TabContext>

      <EditFAQ
        itemToEdit={editItem}
        setItemToEdit={setEditItem}
        data={faqs}
        setData={setFaqs}
        refresh={refresh}
        setRefresh={setRefresh}
        endpoint={"partnership"}
        attribute={"faq"}
      />
    </>
  );
}
